
import React from "react";
import { View } from "react-native";
import { COLORS } from "../constant";

const CDivider = React.memo(({ height = 1, color = COLORS.divider, ...otherProps }) => (
  <View style={[{ height: height, backgroundColor: color, width: "100%" }, otherProps.style]} />
));

export default CDivider;

